import React from "react";
import { ArrowRight, MessageSquare } from "lucide-react";

const BG =
  "https://customer-assets.emergentagent.com/job_maritime-solutions-10/artifacts/t0xwlg3s_094E0458-3D97-4A65-AD3A-02FC17558DBB.png";

export default function CTABanner() {
  return (
    <section
      data-testid="cta-banner-section"
      className="relative py-24 sm:py-32 overflow-hidden bg-[#0A1128] text-white"
    >
      <div className="absolute inset-0">
        <img
          src={BG}
          alt=""
          className="w-full h-full object-cover opacity-40"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0A1128] via-[#0A1128]/95 to-[#0A1128]/75" />
      </div>

      <div className="relative max-w-7xl mx-auto px-6 lg:px-12">
        <div className="max-w-3xl">
          <div className="flex items-center gap-3 mb-6">
            <span className="h-px w-12 bg-[#D90429]" />
            <span className="kms-overline">Prêt à collaborer ?</span>
          </div>

          <h2 className="font-heading font-black text-4xl sm:text-5xl lg:text-6xl tracking-tighter leading-[1.02]">
            Faites de KMS<br />
            <span className="text-[#D90429]">votre partenaire</span><br />
            maritime.
          </h2>

          <p className="mt-8 text-lg text-white/75 max-w-xl leading-relaxed">
            Une demande de devis, une question logistique, un besoin
            d'approvisionnement urgent ? Notre équipe répond sous 24h.
          </p>

          <div className="mt-10 flex flex-wrap gap-4">
            <a href="#contact" data-testid="cta-banner-quote" className="kms-btn-light">
              Demander un devis
              <ArrowRight size={18} />
            </a>
            <a
              href="https://wa.me/2250505352727"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="cta-banner-whatsapp"
              className="inline-flex items-center gap-2 text-white font-semibold border border-white/30 px-7 py-4 hover:border-[#D90429] hover:text-[#D90429] transition-all"
            >
              <MessageSquare size={18} />
              WhatsApp · +225 05 05 35 27 27
            </a>
          </div>

          <div className="mt-16 grid grid-cols-2 sm:grid-cols-4 gap-6 border-t border-white/15 pt-10 max-w-3xl">
            {[
              { v: "24h", l: "Délai de réponse" },
              { v: "100%", l: "Engagement qualité" },
              { v: "CI", l: "Présence locale" },
              { v: "8+", l: "Lignes de service" },
            ].map((s) => (
              <div key={s.l}>
                <div className="font-heading font-black text-2xl sm:text-3xl text-white">
                  {s.v}
                </div>
                <div className="text-[0.65rem] uppercase tracking-[0.25em] text-white/55 mt-2">
                  {s.l}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
